<template>

    <div v-if="fetcher.initialized">

    	<div class="row mb-4">

    		<div class="col-12 col-md-4">
    			<select class="form-select new-list-group-field" v-model="settings.query.year">
    				<option :value="null">Välj år</option>
                    <option :key="'y'+year" v-for="year in filterYears">{{ year }}</option>
    			</select>
    		</div>

    	</div>

        <list ref="list" :settings="settings" :query.sync="settings.query" :useCookies="false">
            <div slot="item-row" slot-scope="props">
                <div class="row g-3">
                    <div class="col-3" style="text-transform: capitalize;">
                        {{ props.item.month }} {{ props.item.year }}
                    </div>
                    <div class="col-6">
                        <span v-if="props.item.sum_monthly">Månadskostnad </span>
                        <span v-if="props.item.subscription.type === 'pay_per_treatment'">Månadens behandlingar </span>

                        <span v-if="props.item.start_fee" style="display: inline-block; margin-left: 4px;">
                             och startavgift
                        </span>
                        <span v-if="props.item.sum_monthly && props.item.sum_settlement">
                             för {{ props.item.month }}.
                        </span>
                        <span v-if="props.item.sum_settlement">
                            Avräkning för {{ props.item.period_settlement.from_date }} - {{ props.item.period_settlement.to_date }}.
                        </span>
                    </div>
                    <div class="col-3">
                        <span v-if="props.item.start_fee">
                            {{ props.item.start_fee }} kr
                        </span>
                    </div>
                    <div class="col-3">
                        <span v-if="props.item.sum_monthly">
                            {{ props.item.sum_monthly }} kr
                        </span>
                    </div>
                    <div class="col-4">
                        <span v-if="props.item.num_settlement_treatments">
                            {{ props.item.num_settlement_treatments }} extra behandlingar
                        </span>
                        <span v-if="props.item.num_no_show_treatments">
                            {{ props.item.num_no_show_treatments }} sena avbokningar
                        </span>
                        <span v-if="props.item.subscription.type === 'pay_per_treatment'">
                            {{ props.item.num_total_treatments }} behandlingar
                        </span>
                    </div>
                    <div class="col-2">
                        <span>
                            {{ props.item.sum_total }} kr
                        </span>
                    </div>
                    <div class="col-3">
                        <span v-if="props.item.sum_settlement || props.item.sum_no_show  || props.item.subscription.type === 'pay_per_treatment'">
                            <a target="_blank" :href="props.item.admin_url_pdf">
                                <span class="fa fa-arrow-down" style="margin-right: 4px;"></span>
                                Specifikation
                            </a>
                        </span>
                    </div>
                </div>
            </div>
        </list>

		<div class="new-list-group d-none">

    		<div class="new-list-group-item new-list-group-header">

    			<div class="row g-3">
					<div class="col-3"><span>Period</span> <li class="fa fa-sort-amount-desc" style="margin-left: 4px;"></li></div>
					<div class="col-5"><span>Beskrivning</span></div>
                    <div class="col-3"><span>Startavg.</span></div>
					<div class="col-3"><span>Månadskostnad</span></div>
					<div class="col-3"><span>Extra</span></div>
					<div class="col-3"><span>Á pris</span></div>
					<div class="col-2"><span>Totalt</span></div>
					<div class="col-2"><span>Spec.</span></div>
				</div>

    		</div>

            Med startavgift:
            <div class="new-list-group-item">

                <div class="row g-3">
                    <div class="col-3"><span>Augusti 2022</span></div>
                    <div class="col-5"><span>Månadskostnad och startavgift</span></div>
                    <div class="col-3">500 kr</div>
                    <div class="col-3"><span>4500 kr</span></div>
                    <div class="col-3"><span></span></div>
                    <div class="col-3"><span></span></div>
                    <div class="col-2"><span>5000 kr</span></div>
                    <div class="col-2"><span></span></div>
                </div>

            </div>

    		För abonnemangstyp 1-2:
    		<div class="new-list-group-item">

				<div class="row g-3">
					<div class="col-3"><span>Augusti 2022</span></div>
					<div class="col-5"><span>Månadskostnad</span></div>
                    <div class="col-3"></div>
					<div class="col-3"><span>4500 kr</span></div>
					<div class="col-3"><span></span></div>
					<div class="col-3"><span></span></div>
					<div class="col-2"><span>4500 kr</span></div>
					<div class="col-2"><span></span></div>
				</div>

    		</div>

    		<div class="new-list-group-item">

				<div class="row g-3">
					<div class="col-3"><span>Juli 2022</span></div>
					<div class="col-5"><span>Månadskostnad för juli och periodavräkning för januari-juni 2022</span></div>
                    <div class="col-3"></div>
					<div class="col-3"><span>4500 kr</span></div>
					<div class="col-3"><span>7 extra behandlingar</span></div>
					<div class="col-3"><span>250 kr</span></div>
					<div class="col-2"><span>6250 kr</span></div>
					<div class="col-2"><span><a href=""><span class="fa fa-arrow-down" style="margin-right: 4px;"></span>Spec</a></span></div>
				</div>

    		</div>

    		För abonnemangstyp 3:
    		<div class="new-list-group-item">

				<div class="row g-3">
					<div class="col-3"><span>Juli 2022</span></div>
					<div class="col-5"><span>Månadens behandlingar</span></div>
                    <div class="col-3"></div>
					<div class="col-3"><span></span></div>
					<div class="col-3"><span>22 behandlingar</span></div>
					<div class="col-3"><span>M: 400 kr / F: 500 kr</span></div>
					<div class="col-2"><span>9900 kr</span></div>
					<div class="col-2"><span><a href=""><span class="fa fa-arrow-down" style="margin-right: 4px;"></span>Spec</a></span></div>
				</div>

    		</div>

    	</div>

    </div>

</template>

<script>
import moment from 'moment'
import lister from '../../../../shared/mixins/lister'
import fetcher from '../../../../shared/mixins/fetcher'

export default {

    mixins: [
        lister,
        fetcher
    ],

    props: {
        company_id: {
            required: true
        }
    },

    data () {
        return {
            company: null,
            first_contract_starts_at: null,
            fetcher: {
                autoFill: ['company', 'first_contract_starts_at']
            },
            settings: {
                url: '/companies/' + this.company_id + '/billing/list',
                query: {
                    year: null
                },
                columns: [
                    { column: 'id', name: 'Period', class: 'col-3', sortable: true, default: true },
                    { column: 'description', name: 'Beskrivning', class: 'col-6', sortable: false },
                    { column: 'start_fee', name: 'Startavg.', class: 'col-3', sortable: false },
                    { column: 'monthly_fee', name: 'Månadskostnad', class: 'col-3', sortable: false },
                    { column: 'extra', name: 'Extra', class: 'col-4', sortable: false },
                    { column: 'total', name: 'Totalt', class: 'col-2', sortable: false },
                    { column: 'pdf', name: 'Specifikation', class: 'col-3', sortable: false }
                ],
                bulk_actions: []
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/companies/' + this.company_id + '/tabBilling'
        },

        filterYears () {
            const years = []
            if (!this.first_contract_starts_at) {
                return years
            }

            const date = moment(this.first_contract_starts_at)
            while (date.isBefore(moment())) {
                years.push(date.year())
                date.add(1, 'year')
            }

            return years
        }
    }

}
</script>
